import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Routes,
  Route,
  Link,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  FiGrid,
  FiPackage,
  FiUsers,
  FiMessageSquare,
  FiSettings,
  FiLogOut,
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiCheck,
  FiX,
  FiBriefcase,
  FiDollarSign,
  FiActivity,
  FiMail,
  FiTool,
  FiImage,
} from "react-icons/fi";
import { MdCurrencyRupee } from "react-icons/md";
import API from "../utils/api";
import { useAuth } from "../context/AuthContext";
import toast from "react-hot-toast";
import { FiFileText, FiClipboard, FiCheckSquare, FiTruck, FiEye, FiChevronLeft, FiChevronRight, FiSearch, FiBook, FiUserCheck, FiAlertCircle } from "react-icons/fi";
import AdminCRM from "./AdminCRM"; // adjust path if needed
import AdminSiteSettings from "../components/admin/AdminSiteSettings";
  import AdminEmailSettings from "../components/admin/AdminEmailSettings";
import SalesOrders from "./SalesOrders"; // standalone Orders module — separate from CRM
import AdminPayments from "./AdminPayments"; // Payment ledger for Direct Orders
import AdminBilling  from "./AdminBilling";  // Billing module — generate & manage bills
import BillDetail    from "./BillDetail";    // Bill detail page /admin/billing/:billId
import AdminProduction from "./AdminProduction"; // Production board — process stages across all orders
import AdminDelivered from "./AdminDelivered"; // Delivered orders
import AdminPaymentTerms from "./AdminPaymentTerms"; // Payment policy terms + enforcement
import AddUserModal from "../components/admin/AddUserModal";
import AddBusinessModal from "../components/admin/AddBusinessModal";
import OrderDetailModule from './OrderDetailList'; // NEW — Order Detail sidebar page
import AdminBusinessDetail from './AdminBusinessDetail'; // Full-page business detail
import AdminNotificationBell from '../components/admin/AdminNotificationBell';
import AdminDashboard from './AdminDashboard'; // ← new enhanced dashboard
import AdminStaff from './AdminStaff'; // ← new staff management
import { GRANTABLE_PAGES, pathToKey, canStaffAccess } from '../utils/staffPages'; // ← staff pages
import AdminVendorTypes   from './AdminVendorTypes';
import AdminVendors       from './AdminVendors';
import AdminVendorDetail  from './AdminVendorDetail';
import AdminVendorForm    from './AdminVendorForm';
import AdminVendorPayments from './AdminVendorPayments';
import AdminVendorPaymentDetail from './AdminVendorPaymentDetail';
import AdminServices from './AdminServices';
import AdminPublicServices from './AdminPublicServices';
import AdminClientLogos from './AdminClientLogos';
import AdminAboutUs from './AdminAboutUs';
import AdminPurchases      from './AdminPurchases';
import AdminPurchaseForm   from './AdminPurchaseForm';
import AdminPurchaseDetail from './AdminPurchaseDetail';
import AdminExpenses           from './AdminExpenses';
import AdminExpenseForm        from './AdminExpenseForm';
import AdminExpenseDetail      from './AdminExpenseDetail';
import AdminExpenseCategories  from './AdminExpenseCategories';
import AdminExpenseReports     from './AdminExpenseReports';
// import AdminCashBank           from './AdminCashBank';
import AdminBankAccounts       from './AdminBankAccounts';
import AdminLedger             from './AdminLedger';
import AdminTds                from './AdminTds';
// import Select from "react-select";
// ── Product Catalog ─────────────────────────────────────────────────
import AdminAllProducts    from './products/AdminAllProducts';
import AdminProductForm    from './products/AdminProductForm';
import AdminProductPreview from './products/AdminProductPreview';
import AdminCategories     from './products/AdminCategories';
import AdminSearchAnalytics from './products/AdminSearchAnalytics';
import AdminQuoteRequests  from './AdminQuoteRequests';
import AdminContactHero    from './AdminContactHero';
/* ─── Sidebar ─────────────────────────────────────────────────────── */
const AdminSidebar = ({ open, onClose, collapsed, onToggleCollapse }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  // Close mobile drawer on route change
  useEffect(() => { onClose(); }, [location.pathname]); // eslint-disable-line

  const nav = [
    { path: "/admin",               label: "Dashboard",    icon: <FiGrid size={18} /> },
    
    { path: "/admin/sales-orders",  label: "Sales Order",icon: <FiClipboard size={18} /> },
    { path: "/admin/order-detail",  label: "Designing", icon: <FiEye size={18} /> },
    { path: "/admin/production",    label: "Production",   icon: <FiActivity size={18} /> },
    { path: "/admin/delivered",     label: "Delivery",    icon: <FiTruck size={18} /> },
    { path: "/admin/payments",      label: "Receipts",     icon: <MdCurrencyRupee size={18} /> },
    { path: "/admin/billing",        label: "Tax Invoice",      icon: <FiFileText size={18} /> },
    { path: "/admin/purchases",       label: "Purchases",       icon: <FiFileText size={18} /> },
    // { path: "/admin/vendor-payments", label: "Vendor Payments", icon: <MdCurrencyRupee size={18} />},
    { path: "/admin/expenses",           label: "All Expenses", icon: <FiFileText size={18} /> },
    
    
    
    { path: "/admin/users",         label: "Users",        icon: <FiUsers size={18} /> },
    { path: "/admin/businesses",    label: "Businesses",   icon: <FiBriefcase size={18} /> },
    { path: "/admin/vendors",         label: "All Vendors",     icon: <FiUsers size={18} /> },
    { path: "/admin/contacts",      label: "Messages",     icon: <FiMessageSquare size={18} /> },
    // { path: "/admin/cash-bank",      label: "Cash & Bank",  icon: <MdCurrencyRupee size={18} /> },
    { path: "/admin/ledger",         label: "Ledger",       icon: <FiBook size={18} /> },
    { path: "/admin/tds",            label: "TDS Register", icon: <MdCurrencyRupee size={18} /> },
    { path: "/admin/staff",          label: "Staff",        icon: <FiUserCheck size={18} />, adminOnly: true },
    {
      path: "/admin/vendors",
      label: "Vendors",
      icon: <FiTruck size={18} />,
      children: [
        


{ path: "/admin/vendor-types",    label: "Vendor Types",    icon: <FiFileText size={14} /> },
{ path: "/admin/services",        label: "Services",        icon: <FiTool size={14} /> },
      ],
    },
    {
      path: "/admin/expenses",
      label: "Expenses",
      icon: <MdCurrencyRupee size={18} />,
      children: [
        
        { path: "/admin/expense-categories", label: "Categories",   icon: <FiCheckSquare size={14} /> },
        { path: "/admin/expenses/reports",   label: "Reports",      icon: <FiActivity size={14} /> },
      ],
    },
    { path: "/admin/quotations",    label: "Quotations",   icon: <FiFileText size={18} /> },
    {
      path: "/admin/products",
      label: "Products",
      icon: <FiPackage size={18} />,
      children: [
        { path: "/admin/products",           label: "All Products",     icon: <FiPackage size={14} /> },
        { path: "/admin/catalog/categories", label: "Categories",       icon: <FiFileText size={14} /> },
        { path: "/admin/search-analytics",   label: "Search Analytics", icon: <FiSearch size={14} /> },
      ],
    },
        { path: "/admin/quote-requests", label: "Quote Requests", icon: <FiClipboard size={18} /> },
    {
      path: "/admin/website",
      label: "Website",
      icon: <FiImage size={18} />,
      children: [
        { path: "/admin/public-services",  label: "Services",      icon: <FiTool size={14} /> },
        { path: "/admin/client-logos",     label: "Our Clients",   icon: <FiImage size={14} /> },
        { path: "/admin/about-us",         label: "About Us",      icon: <FiGrid size={14} /> },
        { path: "/admin/contact-hero",     label: "Contact Hero",  icon: <FiImage size={14} /> },
      ],
    },
    {
      path: "/admin/settings",
      label: "Settings",
      icon: <FiSettings size={18} />,
      children: [
        { path: "/admin/payment-terms",   label: "Payment Terms",   icon: <FiFileText size={14} /> },
        { path: "/admin/bank-accounts",   label: "Bank Accounts",   icon: <MdCurrencyRupee size={14} /> },
        { path: "/admin/site-settings",   label: "Site Settings",   icon: <FiSettings size={14} /> },
        { path: "/admin/email-settings",  label: "Email Settings",  icon: <FiMail size={14} /> },
      ],
    },
  ];

  const isLedgerActive = location.pathname.startsWith("/admin/ledger");

  const isProductsActive =
    location.pathname.startsWith("/admin/products") ||
    location.pathname.startsWith("/admin/catalog") ||
    location.pathname.startsWith("/admin/search-analytics");

  const isVendorsActive =
    location.pathname.startsWith("/admin/vendor-types") ||
    location.pathname.startsWith("/admin/services");
  const isWebsiteActive =
    location.pathname.startsWith("/admin/public-services") ||
    location.pathname.startsWith("/admin/client-logos") ||
    location.pathname.startsWith("/admin/about-us") ||
    location.pathname.startsWith("/admin/contact-hero");

  const isSettingsActive =
    location.pathname.startsWith("/admin/settings") ||
    location.pathname.startsWith("/admin/payment-terms") ||
    location.pathname.startsWith("/admin/bank-accounts") ||
    location.pathname.startsWith("/admin/site-settings") ||
    location.pathname.startsWith("/admin/email-settings");

  const isExpensesActive =
    location.pathname.startsWith("/admin/expense-categories") ||
    location.pathname.startsWith("/admin/expenses/reports");

  const [openGroup, setOpenGroup] = React.useState(
    isProductsActive ? "products" :
    isVendorsActive  ? "vendors"  :
    isExpensesActive ? "expenses" :
    isWebsiteActive  ? "website"  :
    isSettingsActive ? "settings" : null
  );

  const toggleGroup = (key) =>
    setOpenGroup((cur) => (cur === key ? null : key));

  const vendorsOpen  = openGroup === "vendors";
  const settingsOpen = openGroup === "settings";
  const expensesOpen = openGroup === "expenses";
  const productsOpen = openGroup === "products";
  const websiteOpen  = openGroup === "website";

  const navLinkStyle = (isActive) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: collapsed ? "center" : "flex-start",
    gap: collapsed ? 0 : 10,
    padding: collapsed ? "10px 0" : "10px 12px",
    borderRadius: 9,
    fontSize: "0.88rem",
    fontWeight: 500,
    background: isActive ? "rgba(255,255,255,0.1)" : "transparent",
    color: isActive ? "#fff" : "rgba(255,255,255,0.55)",
    transition: "all 0.2s",
    whiteSpace: "nowrap",
    overflow: "hidden",
    position: "relative",
  });

  return (
    <>
      {/* Overlay — mobile drawer only */}
      {open && (
        <div className="admin-overlay" onClick={onClose} />
      )}

      <aside className={`admin-sidebar${open ? " sidebar-open" : ""}${collapsed ? " sidebar-collapsed" : ""}`}>

  {/* ── Edge toggle button — sits on right edge of sidebar, hidden on mobile ── */}
  <button
    onClick={onToggleCollapse}
    className="sidebar-collapse-btn sidebar-edge-toggle"
    title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
  >
    {collapsed ? <FiChevronRight size={14} /> : <FiChevronLeft size={14} />}
  </button>

  {/* ── Logo area ── */}
  <div style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 24,
    minHeight: 40,
  }}>
    <Link to="/" style={{ display: "flex", alignItems: "center" }}>
      {collapsed
        ? <img src="/favicon-32x32.png" alt="A" style={{ width: 28, height: 28, borderRadius: 6 }} />
        : <img src="/logo_White.svg" alt="Angel Printers" style={{ height: 32, width: "auto" }} />
      }
    </Link>
  </div>
<div style={{ flex: 1, overflowY: "auto", overflowX: "hidden", marginRight: -12, paddingRight: 12, minHeight: 0 }}>
        {/* ── Nav items ── */}
        {nav
          .filter((n) => {
            // adminOnly items are hidden from staff
            if (n.adminOnly && user?.role !== "admin") return false;
            // For staff, also hide child-group items entirely if no children would be visible
            if (user?.role === "staff") {
              const key = pathToKey(n.path);
              if (n.children) {
                // show the group only if at least one child is accessible
                return n.children.some(c => canStaffAccess(user.allowedPages, pathToKey(c.path)));
              }
              if (n.path === "/admin") return true; // always show dashboard
              return canStaffAccess(user.allowedPages, key);
            }
            return true;
          })
          .map((n) => {
          if (n.children) {
            // Settings parent — expandable group
            return (
              <div key={n.path}>
                <button
            title={collapsed ? n.label : ""}
            onClick={() => {
              if (n.path === "/admin/settings") toggleGroup("settings");
              if (n.path === "/admin/vendors")  toggleGroup("vendors");
              if (n.path === "/admin/expenses") toggleGroup("expenses");
              if (n.path === "/admin/products") toggleGroup("products");
              if (n.path === "/admin/website")  toggleGroup("website");
            }}
                  style={{
                    ...navLinkStyle(
                      n.path === "/admin/vendors"  ? isVendorsActive  :
                      n.path === "/admin/expenses" ? isExpensesActive :
                      n.path === "/admin/products" ? isProductsActive :
                      n.path === "/admin/website"  ? isWebsiteActive  :
                      isSettingsActive
                    ),
                    width: "100%",
                    border: "none",
                    cursor: "pointer",
                    justifyContent: collapsed ? "center" : "space-between",
                  }}
                >
                  <span style={{ display: "flex", alignItems: "center", gap: collapsed ? 0 : 10 }}>
                    <span style={{ flexShrink: 0, display: "flex" }}>{n.icon}</span>
                    {!collapsed && (
                      <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{n.label}</span>
                    )}
                  </span>
                </button>
                {((n.path === "/admin/settings" && settingsOpen) ||
                  (n.path === "/admin/vendors"  && vendorsOpen) ||
                  (n.path === "/admin/expenses" && expensesOpen) ||
                  (n.path === "/admin/products" && productsOpen) ||
                  (n.path === "/admin/website"  && websiteOpen)) && !collapsed && (
                  <div style={{ paddingLeft: 14, marginTop: 2 }}>
                    {n.children.map((child) => {
                      const childActive = location.pathname === child.path ||
                        location.pathname.startsWith(child.path + "/");
                      return (
                        <Link
                          key={child.path}
                          to={child.path}
                          style={{
                            ...navLinkStyle(childActive),
                            fontSize: "0.82rem",
                            padding: "8px 10px",
                          }}
                        >
                          <span style={{ flexShrink: 0, display: "flex" }}>{child.icon}</span>
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{child.label}</span>
                        </Link>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          }

          const isActive =
            n.path === "/admin"
              ? location.pathname === "/admin"
              : location.pathname === n.path ||
                location.pathname.startsWith(n.path + "/");
          return (
            <Link
              key={n.path}
              to={n.path}
              title={collapsed ? n.label : ""}
              style={navLinkStyle(isActive)}
            >
              <span style={{ flexShrink: 0, display: "flex" }}>{n.icon}</span>
              {!collapsed && (
                <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                  {n.label}
                </span>
              )}
            </Link>
          );
        })}
</div>
        {/* ── Bottom section ── */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.1)", paddingTop: 12, flexShrink: 0 }}>

          {/* Notification bell */}
          <div style={{
            display: "flex",
            justifyContent: collapsed ? "center" : "flex-start",
            padding: collapsed ? "4px 0" : "0 4px",
            marginBottom: 8,
          }}>
            <AdminNotificationBell />
          </div>

          {/* User info — hidden when collapsed */}
          {!collapsed && (
            <div style={{ padding: "6px 12px", marginBottom: 6 }}>
              <div style={{ fontSize: "0.82rem", fontWeight: 600, color: "#fff" }}>
                {user?.name}
              </div>
              <div style={{ fontSize: "0.72rem", color: "rgba(255,255,255,0.4)" }}>
                {user?.role === "staff" ? (user?.designation || "Staff") : "Administrator"}
              </div>
            </div>
          )}

          {/* Logout */}
          <button
            onClick={logout}
            title={collapsed ? "Logout" : ""}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: collapsed ? "center" : "flex-start",
              gap: collapsed ? 0 : 10,
              padding: collapsed ? "10px 0" : "10px 12px",
              borderRadius: 9,
              fontSize: "0.88rem",
              color: "rgba(255,255,255,0.55)",
              width: "100%",
              cursor: "pointer",
              fontFamily: "var(--font-body)",
            }}
          >
            <FiLogOut size={18} />
            {!collapsed && "Logout"}
          </button>
        </div>
      </aside>
    </>
  );
};

/* ─── Stat Card ───────────────────────────────────────────────────── */
const StatCard = ({ label, value, color = "var(--primary)", icon }) => (
  <div
    style={{
      background: "#fff",
      border: "1px solid var(--border)",
      borderRadius: "var(--radius-lg)",
      padding: 24,
      display: "flex",
      alignItems: "center",
      gap: 16,
    }}
  >
    <div
      style={{
        width: 52,
        height: 52,
        background: `${color}15`,
        color,
        borderRadius: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.3rem",
        flexShrink: 0,
      }}
    >
      {icon}
    </div>
    <div>
      <div
        style={{
          fontSize: "1.8rem",
          fontWeight: 800,
          fontFamily: "var(--font-display)",
          color,
          lineHeight: 1,
        }}
      >
        {value}
      </div>
      <div
        style={{
          fontSize: "0.82rem",
          color: "var(--text-muted)",
          marginTop: 4,
        }}
      >
        {label}
      </div>
    </div>
  </div>
);

/* ─── Dashboard Overview ──────────────────────────────────────────── */
// Moved to ./AdminDashboard.js — imported at the top of this file.

/* ─── Orders Management ───────────────────────────────────────────── */
const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  const load = () => {
    setLoading(true);
    const q = filter ? `?status=${filter}` : "";
    API.get(`/orders${q}`)
      .then((r) => setOrders(r.data.orders || []))
      .finally(() => setLoading(false));
  };
  useEffect(load, [filter]);

  const statusColors = {
    pending: "#f59e0b",
    confirmed: "#3b82f6",
    processing: "#8b5cf6",
    printing: "#ec4899",
    shipped: "#06b6d4",
    delivered: "#059669",
    cancelled: "#ef4444",
  };

  const updateStatus = async (id, status) => {
    const tracking =
      status === "shipped" ? prompt("Enter tracking number (optional):") : null;
    try {
      await API.put(`/orders/${id}/status`, {
        status,
        trackingNumber: tracking || undefined,
      });
      toast.success("Order updated!");
      load();
    } catch {
      toast.error("Failed.");
    }
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <h2>Orders</h2>
        <select
          className="form-control"
          style={{ width: "auto" }}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        >
          <option value="">All Statuses</option>
          {Object.keys(statusColors).map((s) => (
            <option key={s} value={s}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </option>
          ))}
        </select>
      </div>
      {loading ? (
        <div className="spinner" />
      ) : (
        <div
          style={{
            background: "#fff",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-lg)",
            overflow: "hidden",
            overflowX: "auto",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "0.85rem",
              minWidth: 700,
            }}
          >
            <thead>
              <tr
                style={{
                  borderBottom: "2px solid var(--border)",
                  background: "var(--bg-soft)",
                }}
              >
                {[
                  "Order #",
                  "Customer",
                  "Items",
                  "Total",
                  "Status",
                  "Date",
                  "Action",
                ].map((h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "12px 14px",
                      fontWeight: 600,
                      color: "var(--text-muted)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {orders.map((o) => (
                <tr
                  key={o.id}
                  style={{ borderBottom: "1px solid var(--border)" }}
                >
                  <td
                    style={{
                      padding: "12px 14px",
                      fontWeight: 700,
                      color: "var(--primary)",
                    }}
                  >
                    {o.orderNumber}
                  </td>
                  <td style={{ padding: "12px 14px" }}>
                    <div style={{ fontWeight: 500 }}>{o.user?.name || "–"}</div>
                    <div
                      style={{
                        fontSize: "0.75rem",
                        color: "var(--text-muted)",
                      }}
                    >
                      {o.user?.email}
                    </div>
                  </td>
                  <td
                    style={{ padding: "12px 14px", color: "var(--text-muted)" }}
                  >
                    {o.items?.length || 0} item(s)
                  </td>
                  <td style={{ padding: "12px 14px", fontWeight: 700 }}>
                    ₹{parseFloat(o.totalAmount).toFixed(2)}
                  </td>
                  <td style={{ padding: "12px 14px" }}>
                    <span
                      style={{
                        padding: "4px 10px",
                        borderRadius: 100,
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        background: `${statusColors[o.status] || "#999"}20`,
                        color: statusColors[o.status] || "#999",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {o.status}
                    </span>
                  </td>
                  <td
                    style={{
                      padding: "12px 14px",
                      color: "var(--text-muted)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {new Date(o.createdAt).toLocaleDateString()}
                  </td>
                  <td style={{ padding: "12px 14px" }}>
                    <select
                      style={{
                        fontSize: "0.78rem",
                        padding: "5px 8px",
                        border: "1px solid var(--border)",
                        borderRadius: 7,
                        cursor: "pointer",
                        background: "#fff",
                      }}
                      value={o.status}
                      onChange={(e) => updateStatus(o.id, e.target.value)}
                    >
                      {[
                        "pending",
                        "confirmed",
                        "processing",
                        "printing",
                        "shipped",
                        "delivered",
                        "cancelled",
                      ].map((s) => (
                        <option key={s} value={s}>
                          {s}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

/* ─── Users Management ────────────────────────────────────────────── */
const USERS_PAGE_SIZE = 20;

const AdminUsers = () => {
  const { user: currentUser } = useAuth();
  const canEdit = currentUser?.role === 'admin' || canStaffAccess(currentUser?.allowedPages, 'users', 'edit');
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showAddUser, setShowAddUser] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [stats, setStats] = useState({ totalUsers: 0, activeUsers: 0, inactiveUsers: 0 });

  const load = (targetPage = page) => {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.set("search", search);
    if (roleFilter) params.set("role", roleFilter);
    params.set("page", targetPage);
    params.set("limit", USERS_PAGE_SIZE);
    API.get(`/admin/users?${params}`)
      .then((r) => {
        setUsers(r.data.users || []);
        setTotalPages(r.data.pages || 1);
        setTotalCount(r.data.count || 0);
        if (r.data.stats) setStats(r.data.stats);
        setPage(targetPage);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleFilter]);

  const handleSearch = (e) => {
    e.preventDefault();
    load(1);
  };

  const goPrevUsers = () => { if (page > 1) load(page - 1); };
  const goNextUsers = () => { if (page < totalPages) load(page + 1); };

  const toggleStatus = async (user) => {
    if (
      !window.confirm(
        `${user.isActive ? "Deactivate" : "Activate"} user "${user.name}"?`,
      )
    )
      return;
    try {
      await API.put(`/admin/users/${user.id}`, {
        isActive: !user.isActive,
        role: user.role,
      });
      toast.success(`User ${user.isActive ? "deactivated" : "activated"}!`);
      load();
    } catch {
      toast.error("Failed.");
    }
  };

  const totalSpent = (orders) => {
    if (!orders || orders.length === 0) return 0;
    return orders.reduce((sum, o) => sum + parseFloat(o.totalAmount || 0), 0);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <h2>
          Users{" "}
          <span
            style={{
              fontSize: "1rem",
              color: "var(--text-muted)",
              fontWeight: 400,
            }}
          >
            ({totalCount})
          </span>
        </h2>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <form onSubmit={handleSearch} style={{ display: "flex", gap: 8 }}>
            <input
              className="form-control"
              placeholder="Search name, email, phone..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ width: 240, fontSize: "0.88rem" }}
            />
            <button type="submit" className="btn btn-primary btn-sm">
              Search
            </button>
          </form>
          <select
            className="form-control"
            style={{ width: "auto", fontSize: "0.88rem" }}
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
          >
            <option value="">All Roles</option>
            <option value="user">Users</option>
            <option value="admin">Admins</option>
          </select>
          {canEdit && (
            <button
              onClick={() => setShowAddUser(true)}
              className="btn btn-primary btn-sm"
              style={{ display: "flex", alignItems: "center", gap: 6 }}
            >
              ➕ Add User
            </button>
          )}
        </div>
      </div>

      {/* Stats Bar */}
      <div className="admin-stat-grid">
        {[
          {
            label: "Total Users",
            value: stats.totalUsers,
            color: "#3b82f6",
            emoji: "👥",
          },
          {
            label: "Active Users",
            value: stats.activeUsers,
            color: "#059669",
            emoji: "✅",
          },
          {
            label: "Inactive Users",
            value: stats.inactiveUsers,
            color: "#ef4444",
            emoji: "🚫",
          },
        ].map((s) => (
          <div
            key={s.label}
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius-lg)",
              padding: "16px 20px",
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <span style={{ fontSize: "1.8rem" }}>{s.emoji}</span>
            <div>
              <div
                style={{
                  fontSize: "1.6rem",
                  fontWeight: 800,
                  fontFamily: "var(--font-display)",
                  color: s.color,
                  lineHeight: 1,
                }}
              >
                {s.value}
              </div>
              <div
                style={{
                  fontSize: "0.78rem",
                  color: "var(--text-muted)",
                  marginTop: 2,
                }}
              >
                {s.label}
              </div>
            </div>
          </div>
        ))}
      </div>

      {loading ? (
        <div className="spinner" />
      ) : users.length === 0 ? (
        <div
          style={{
            background: "#fff",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-lg)",
            padding: 48,
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "3rem", marginBottom: 12 }}>👥</div>
          <h3>No users found</h3>
          <p style={{ color: "var(--text-muted)", marginTop: 8 }}>
            Try adjusting your search or filter.
          </p>
        </div>
      ) : (
        <div
          style={{
            background: "#fff",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-lg)",
            overflow: "hidden",
            overflowX: "auto",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "0.85rem",
              minWidth: 800,
            }}
          >
            <thead>
              <tr
                style={{
                  borderBottom: "2px solid var(--border)",
                  background: "var(--bg-soft)",
                }}
              >
                {[
                  "User",
                  "Email",
                  "Phone",
                  "Role",
                  "Orders",
                  "Total Spent",
                  "Joined",
                  "Status",
                  "Action",
                ].map((h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "12px 14px",
                      fontWeight: 600,
                      color: "var(--text-muted)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr
                  key={u.id}
                  style={{
                    borderBottom: "1px solid var(--border)",
                    background: u.isActive ? "#fff" : "#fafafa",
                  }}
                >
                  {/* User */}
                  <td style={{ padding: "12px 14px" }}>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <div
                        style={{
                          width: 36,
                          height: 36,
                          borderRadius: "50%",
                          background:
                            u.role === "admin" ? "#7c3aed" : "var(--primary)",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 700,
                          fontFamily: "var(--font-display)",
                          fontSize: "0.9rem",
                          flexShrink: 0,
                        }}
                      >
                        {u.name?.[0]?.toUpperCase()}
                      </div>
                      <div>
                        <div style={{ fontWeight: 600 }}>{u.name}</div>
                        <div
                          style={{
                            fontSize: "0.72rem",
                            color: "var(--text-muted)",
                          }}
                        >
                          ID: {u.id}
                        </div>
                      </div>
                    </div>
                  </td>
                  {/* Email */}
                  <td style={{ padding: "12px 14px" }}>
                    <a
                      href={`mailto:${u.email}`}
                      style={{ color: "var(--primary)", fontSize: "0.85rem" }}
                    >
                      {u.email}
                    </a>
                  </td>
                  {/* Phone */}
                  <td
                    style={{
                      padding: "12px 14px",
                      color: "var(--text-muted)",
                      fontSize: "0.85rem",
                    }}
                  >
                    {u.phone || "—"}
                  </td>
                  {/* Role */}
                  <td style={{ padding: "12px 14px" }}>
                    <span
                      style={{
                        padding: "3px 10px",
                        borderRadius: 100,
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        background:
                          u.role === "admin"
                            ? "rgba(124,58,237,0.1)"
                            : "rgba(59,130,246,0.1)",
                        color: u.role === "admin" ? "#7c3aed" : "#2563eb",
                      }}
                    >
                      {u.role}
                    </span>
                  </td>
                  {/* Orders */}
                  <td
                    style={{
                      padding: "12px 14px",
                      textAlign: "center",
                      fontWeight: 600,
                    }}
                  >
                    {u.orders?.length || 0}
                  </td>
                  {/* Total Spent */}
                  <td
                    style={{
                      padding: "12px 14px",
                      fontWeight: 700,
                      color: "#059669",
                    }}
                  >
                    ₹{totalSpent(u.orders).toFixed(2)}
                  </td>
                  {/* Joined */}
                  <td
                    style={{
                      padding: "12px 14px",
                      color: "var(--text-muted)",
                      whiteSpace: "nowrap",
                      fontSize: "0.82rem",
                    }}
                  >
                    {new Date(u.createdAt).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </td>
                  {/* Status */}
                  <td style={{ padding: "12px 14px" }}>
                    <span
                      style={{
                        padding: "3px 10px",
                        borderRadius: 100,
                        fontSize: "0.75rem",
                        fontWeight: 600,
                        background: u.isActive
                          ? "rgba(5,150,105,0.1)"
                          : "rgba(239,68,68,0.1)",
                        color: u.isActive ? "#059669" : "#ef4444",
                      }}
                    >
                      {u.isActive ? "Active" : "Inactive"}
                    </span>
                  </td>
                  {/* Actions */}
                  <td style={{ padding: "12px 14px" }}>
                    <div style={{ display: "flex", gap: 6 }}>
                      <button
                        onClick={() => setSelectedUser(u)}
                        style={{
                          padding: "5px 10px",
                          border: "1px solid var(--border)",
                          borderRadius: 7,
                          cursor: "pointer",
                          fontSize: "0.78rem",
                          background: "#fff",
                        }}
                      >
                        👁 View
                      </button>
                      {canEdit && u.role !== "admin" && (
                        <button
                          onClick={() => toggleStatus(u)}
                          style={{
                            padding: "5px 10px",
                            border: `1px solid ${u.isActive ? "rgba(239,68,68,0.3)" : "rgba(5,150,105,0.3)"}`,
                            borderRadius: 7,
                            cursor: "pointer",
                            fontSize: "0.78rem",
                            color: u.isActive ? "#ef4444" : "#059669",
                            background: u.isActive
                              ? "rgba(239,68,68,0.05)"
                              : "rgba(5,150,105,0.05)",
                          }}
                        >
                          {u.isActive ? "🚫 Deactivate" : "✅ Activate"}
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* User Detail Modal */}
      {selectedUser && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 20,
          }}
          onClick={() => setSelectedUser(null)}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "var(--radius-lg)",
              padding: 32,
              maxWidth: 520,
              width: "100%",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 24,
              }}
            >
              <h3>User Details</h3>
              <button
                onClick={() => setSelectedUser(null)}
                style={{
                  fontSize: "1.2rem",
                  cursor: "pointer",
                  color: "var(--text-muted)",
                }}
              >
                ✕
              </button>
            </div>
            {/* Avatar & Name */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                marginBottom: 24,
                padding: 20,
                background: "var(--bg-soft)",
                borderRadius: "var(--radius-lg)",
              }}
            >
              <div
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: "50%",
                  background:
                    selectedUser.role === "admin"
                      ? "#7c3aed"
                      : "var(--primary)",
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 800,
                  fontSize: "1.4rem",
                  fontFamily: "var(--font-display)",
                  flexShrink: 0,
                }}
              >
                {selectedUser.name?.[0]?.toUpperCase()}
              </div>
              <div>
                <div style={{ fontWeight: 700, fontSize: "1.1rem" }}>
                  {selectedUser.name}
                </div>
                <div
                  style={{ fontSize: "0.85rem", color: "var(--text-muted)" }}
                >
                  {selectedUser.email}
                </div>
                <span
                  style={{
                    padding: "2px 8px",
                    borderRadius: 100,
                    fontSize: "0.72rem",
                    fontWeight: 600,
                    background:
                      selectedUser.role === "admin"
                        ? "rgba(124,58,237,0.1)"
                        : "rgba(59,130,246,0.1)",
                    color:
                      selectedUser.role === "admin" ? "#7c3aed" : "#2563eb",
                    marginTop: 4,
                    display: "inline-block",
                  }}
                >
                  {selectedUser.role}
                </span>
              </div>
            </div>
            {/* Details */}
            {[
              ["📧 Email", selectedUser.email],
              ["📱 Phone", selectedUser.phone || "Not provided"],
              ["🏠 Address", selectedUser.address || "Not provided"],
              [
                "📅 Joined",
                new Date(selectedUser.createdAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }),
              ],
              ["✅ Status", selectedUser.isActive ? "Active" : "Inactive"],
              ["🛍 Total Orders", selectedUser.orders?.length || 0],
              [
                "💰 Total Spent",
                `₹${totalSpent(selectedUser.orders).toFixed(2)}`,
              ],
            ].map(([label, value]) => (
              <div
                key={label}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "1px solid var(--border)",
                  fontSize: "0.88rem",
                }}
              >
                <span style={{ color: "var(--text-muted)" }}>{label}</span>
                <span
                  style={{ fontWeight: 500, textAlign: "right", maxWidth: 280 }}
                >
                  {value}
                </span>
              </div>
            ))}
            {/* Recent Orders */}
            {selectedUser.orders?.length > 0 && (
              <div style={{ marginTop: 20 }}>
                <h4 style={{ marginBottom: 12, fontSize: "0.9rem" }}>
                  Recent Orders
                </h4>
                {selectedUser.orders.slice(0, 5).map((o) => (
                  <div
                    key={o.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "8px 12px",
                      background: "var(--bg-soft)",
                      borderRadius: 8,
                      marginBottom: 6,
                      fontSize: "0.82rem",
                    }}
                  >
                    <span style={{ color: "var(--text-muted)" }}>
                      Order #{o.id}
                    </span>
                    <span style={{ fontWeight: 600 }}>
                      ₹{parseFloat(o.totalAmount).toFixed(2)}
                    </span>
                    <span style={{ color: "var(--text-muted)" }}>
                      {new Date(o.createdAt).toLocaleDateString()}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Pagination */}
      {!loading && users.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 14,
            marginTop: 18,
          }}
        >
          <button
            className="btn btn-outline btn-sm"
            onClick={goPrevUsers}
            disabled={page <= 1}
            style={{ opacity: page <= 1 ? 0.5 : 1 }}
          >
            ← Prev
          </button>
          <span style={{ fontSize: "0.85rem", color: "var(--text-muted)" }}>
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-outline btn-sm"
            onClick={goNextUsers}
            disabled={page >= totalPages}
            style={{ opacity: page >= totalPages ? 0.5 : 1 }}
          >
            Next →
          </button>
        </div>
      )}

      {/* Add User Modal */}
      {showAddUser && (
        <AddUserModal
          onClose={() => setShowAddUser(false)}
          onCreated={() => {
            setShowAddUser(false);
            load();
          }}
        />
      )}
    </div>
  );
};

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    API.get("/contact")
      .then((r) => setContacts(r.data.contacts || []))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const updateStatus = async (id, status) => {
    await API.put(`/contact/${id}`, { status });
    toast.success("Updated!");
    load();
  };

  const statusColors = {
    new: "var(--primary)",
    read: "#3b82f6",
    replied: "#059669",
    closed: "var(--text-muted)",
  };

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>Messages</h2>
      {loading ? (
        <div className="spinner" />
      ) : contacts.length === 0 ? (
        <div
          style={{
            background: "#fff",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-lg)",
            padding: 40,
            textAlign: "center",
          }}
        >
          <p style={{ color: "var(--text-muted)" }}>No messages yet.</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          {contacts.map((c) => (
            <div
              key={c.id}
              style={{
                background: "#fff",
                border: "1px solid var(--border)",
                borderRadius: "var(--radius-lg)",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 12,
                  marginBottom: 12,
                }}
              >
                <div>
                  <span style={{ fontWeight: 700 }}>{c.name}</span>
                  <span style={{ color: "var(--text-muted)", margin: "0 8px" }}>
                    ·
                  </span>
                  <a
                    href={`mailto:${c.email}`}
                    style={{ color: "var(--primary)", fontSize: "0.88rem" }}
                  >
                    {c.email}
                  </a>
                  {c.phone && (
                    <>
                      <span
                        style={{ color: "var(--text-muted)", margin: "0 8px" }}
                      >
                        ·
                      </span>
                      <span style={{ fontSize: "0.88rem" }}>{c.phone}</span>
                    </>
                  )}
                </div>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <span
                    style={{
                      padding: "3px 10px",
                      borderRadius: 100,
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      background: `${statusColors[c.status]}20`,
                      color: statusColors[c.status],
                    }}
                  >
                    {c.status}
                  </span>
                  <select
                    style={{
                      fontSize: "0.78rem",
                      padding: "4px 8px",
                      border: "1px solid var(--border)",
                      borderRadius: 7,
                      cursor: "pointer",
                    }}
                    value={c.status}
                    onChange={(e) => updateStatus(c.id, e.target.value)}
                  >
                    {["new", "read", "replied", "closed"].map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              {c.subject && (
                <div
                  style={{
                    fontWeight: 600,
                    marginBottom: 6,
                    fontSize: "0.9rem",
                  }}
                >
                  {c.subject}
                </div>
              )}
              <p
                style={{
                  color: "var(--text-muted)",
                  fontSize: "0.88rem",
                  lineHeight: 1.65,
                }}
              >
                {c.message}
              </p>
              <div
                style={{
                  fontSize: "0.75rem",
                  color: "var(--text-muted)",
                  marginTop: 10,
                }}
              >
                {new Date(c.createdAt).toLocaleString()} · {c.type}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

/* ─── Business Detail Modal ────────────────────────────────────────── */
const EMPTY_CONTACT = { name: "", designation: "", department: "", phone: "", alternatePhone: "", email: "", isPrimary: false, notes: "" };

const BizDetailModal = ({ selected, onClose, handleVerify, COMPANY_TYPES }) => {
  const [activeTab, setActiveTab] = useState("Contacts");
  const tabs = ["Contacts", "Business Info", "Bank & Docs", "Notes", "Credit"];

  // ── Credit state ────────────────────────────────────────────────────────────
  const hasCreditSaved = selected.creditLimit != null || selected.creditTenureDays != null || selected.creditTerms;
  const [creditEditMode, setCreditEditMode] = useState(!hasCreditSaved); // start in form if nothing saved yet
  const [credit, setCredit] = useState({
    creditLimit: selected.creditLimit ?? "",
    creditTenureDays: selected.creditTenureDays ?? "",
    creditTerms: selected.creditTerms ?? "",
  });
  // Saved snapshot — shown in the card view; updated after a successful save
  const [savedCredit, setSavedCredit] = useState({
    creditLimit: selected.creditLimit,
    creditTenureDays: selected.creditTenureDays,
    creditTerms: selected.creditTerms ?? "",
  });
  const [creditSaving, setCreditSaving] = useState(false);
  // Remembers the real limit before deactivation so it can be restored on re-activation
  const previousCreditLimit = useRef(selected.creditLimit);
  // Keep a live copy of isVerified so saveCredit always sends the correct boolean
  const [isVerifiedLive, setIsVerifiedLive] = useState(!!selected.isVerified);

  // ── Live credit usage (fetched from sales orders) ───────────────────────────
  const [creditSummary, setCreditSummary] = useState(null);
  const [creditSummaryLoading, setCreditSummaryLoading] = useState(false);

  useEffect(() => {
    if (activeTab === "Credit" && selected.id && hasCreditSaved) {
      setCreditSummaryLoading(true);
      API.get(`/sales-orders/credit-summary/${selected.id}`)
        .then(({ data }) => setCreditSummary(data))
        .catch(() => setCreditSummary(null))
        .finally(() => setCreditSummaryLoading(false));
    }
  }, [activeTab, selected.id]);

  const saveCredit = async () => {
    setCreditSaving(true);
    try {
      const notesValue = document.getElementById("admin-notes")?.value ?? selected.notes ?? "";
      const payload = {
        isVerified: isVerifiedLive,
        notes: notesValue,
        creditLimit: credit.creditLimit === "" ? null : Number(credit.creditLimit),
        creditTenureDays: credit.creditTenureDays === "" ? null : Number(credit.creditTenureDays),
        creditTerms: credit.creditTerms || null,
      };
      await API.put(`/business/${selected.id}/verify`, payload);
      setSavedCredit({
        creditLimit: payload.creditLimit,
        creditTenureDays: payload.creditTenureDays,
        creditTerms: payload.creditTerms ?? "",
      });
      setCreditEditMode(false);
      toast.success("Credit settings saved!");
    } catch (err) {
      const msg = err?.response?.data?.message || "Failed to save credit settings.";
      toast.error(msg);
    } finally {
      setCreditSaving(false);
    }
  };

  const deleteCredit = async () => {
    if (!window.confirm("Remove credit facility for this business?")) return;
    setCreditSaving(true);
    try {
      const notesValue = document.getElementById("admin-notes")?.value ?? selected.notes ?? "";
      await API.put(`/business/${selected.id}/verify`, {
        isVerified: isVerifiedLive,
        notes: notesValue,
        creditLimit: null,
        creditTenureDays: null,
        creditTerms: null,
      });
      setCredit({ creditLimit: "", creditTenureDays: "", creditTerms: "" });
      setSavedCredit({ creditLimit: null, creditTenureDays: null, creditTerms: "" });
      setCreditEditMode(true);
      toast.success("Credit facility removed.");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to remove credit.");
    } finally {
      setCreditSaving(false);
    }
  };

  const toggleCreditActive = async () => {
    const isDeactivated = savedCredit.creditLimit === 0;
    // When reactivating, restore the original limit stored before deactivation.
    // When deactivating, remember the current limit so it can be restored later.
    const newLimit = isDeactivated ? previousCreditLimit.current : 0;
    if (!isDeactivated) {
      // Save the real limit before zeroing it out
      previousCreditLimit.current = savedCredit.creditLimit;
    }
    const label = isDeactivated ? "Credit reactivated." : "Credit deactivated.";
    setCreditSaving(true);
    try {
      const notesValue = document.getElementById("admin-notes")?.value ?? selected.notes ?? "";
      await API.put(`/business/${selected.id}/verify`, {
        isVerified: isVerifiedLive,
        notes: notesValue,
        creditLimit: newLimit,
        creditTenureDays: savedCredit.creditTenureDays,
        creditTerms: savedCredit.creditTerms || null,
      });
      setSavedCredit((s) => ({ ...s, creditLimit: newLimit }));
      setCredit((c) => ({ ...c, creditLimit: newLimit ?? "" }));
      toast.success(label);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed.");
    } finally {
      setCreditSaving(false);
    }
  };

  // ── Contacts state ──────────────────────────────────────────────────────────
  const [contacts, setContacts]       = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [showForm, setShowForm]       = useState(false);
  const [editingContact, setEditingContact] = useState(null); // null = add mode
  const [form, setForm]               = useState(EMPTY_CONTACT);
  const [saving, setSaving]           = useState(false);

  useEffect(() => {
    if (activeTab === "Contacts") fetchContacts();
  }, [activeTab, selected.id]);

  const fetchContacts = async () => {
    setContactsLoading(true);
    try {
      const r = await API.get(`/business/${selected.id}/contacts`);
      setContacts(r.data.contacts || []);
    } catch { toast.error("Failed to load contacts"); }
    finally { setContactsLoading(false); }
  };

  const openAdd = () => { setForm(EMPTY_CONTACT); setEditingContact(null); setShowForm(true); };
  const openEdit = (c) => { setForm({ name: c.name, designation: c.designation || "", department: c.department || "", phone: c.phone || "", alternatePhone: c.alternatePhone || "", email: c.email || "", isPrimary: c.isPrimary, notes: c.notes || "" }); setEditingContact(c); setShowForm(true); };

  const saveContact = async () => {
    if (!form.name.trim()) { toast.error("Name is required"); return; }
    setSaving(true);
    try {
      if (editingContact) {
        await API.put(`/business/${selected.id}/contacts/${editingContact.id}`, form);
        toast.success("Contact updated");
      } else {
        await API.post(`/business/${selected.id}/contacts`, form);
        toast.success("Contact added");
      }
      setShowForm(false);
      fetchContacts();
    } catch { toast.error("Failed to save contact"); }
    finally { setSaving(false); }
  };

  const deleteContact = async (id) => {
    if (!window.confirm("Delete this contact?")) return;
    try {
      await API.delete(`/business/${selected.id}/contacts/${id}`);
      toast.success("Contact deleted");
      fetchContacts();
    } catch { toast.error("Failed to delete"); }
  };

  const Field = ({ label, value, mono }) => (
    <div style={{ display: "flex", alignItems: "baseline", gap: 16, padding: "9px 0", borderBottom: "1px solid var(--border)" }}>
      <span style={{ minWidth: 160, fontSize: "0.83rem", color: "var(--text-muted)", fontWeight: 500, flexShrink: 0 }}>{label}</span>
      <span style={{ fontSize: "0.88rem", fontFamily: mono ? "monospace" : "inherit", color: "#111" }}>
        {value || <span style={{ color: "#ccc", fontStyle: "italic", fontFamily: "inherit" }}>—</span>}
      </span>
    </div>
  );

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={onClose}
    >
      <div
        style={{ background: "#fff", borderRadius: "var(--radius-lg)", width: "100%", maxWidth: 800, maxHeight: "92vh", overflowY: "auto", display: "flex", flexDirection: "column" }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ── Top bar ── */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 24px", borderBottom: "1px solid var(--border)", background: "var(--bg-soft)", borderRadius: "var(--radius-lg) var(--radius-lg) 0 0" }}>
          <span style={{ fontSize: "0.82rem", fontWeight: 600, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em" }}>Business Details</span>
          <button onClick={onClose} style={{ fontSize: "1rem", cursor: "pointer", color: "var(--text-muted)", background: "none", border: "none", lineHeight: 1, padding: 4 }}>✕</button>
        </div>

        {/* ── Hero section ── */}
        <div style={{ padding: "24px 28px", borderBottom: "1px solid var(--border)", display: "flex", gap: 24, alignItems: "flex-start", flexWrap: "wrap" }}>

          {/* Logo box */}
          <div style={{ width: 110, height: 110, flexShrink: 0, border: "1px solid var(--border)", borderRadius: 10, overflow: "hidden", background: "var(--bg-soft)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            {selected.logoUrl
              ? <img src={selected.logoUrl} alt="logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
              : <span style={{ fontSize: "3rem" }}>🏢</span>
            }
          </div>

          {/* Name + contact */}
          <div style={{ flex: 1, minWidth: 200 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 6 }}>
              <h2 style={{ margin: 0, fontSize: "1.55rem", fontWeight: 800, letterSpacing: "-0.01em" }}>{selected.companyName}</h2>
              <span style={{
                padding: "3px 12px", borderRadius: 100, fontSize: "0.74rem", fontWeight: 600,
                background: selected.isVerified ? "rgba(5,150,105,0.1)" : "rgba(245,158,11,0.1)",
                color: selected.isVerified ? "#059669" : "#d97706",
              }}>
                {selected.isVerified ? "✅ Approved" : "⏳ Pending"}
              </span>
            </div>
            <div style={{ fontSize: "0.85rem", color: "#7c3aed", marginBottom: 8 }}>
              {COMPANY_TYPES[selected.companyType] || selected.companyType}
              {selected.industry ? <span style={{ color: "var(--text-muted)" }}> · {selected.industry}</span> : null}
            </div>
            {selected.contactPersonEmail && (
              <div style={{ fontSize: "0.84rem", color: "#555", display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
                <span>✉</span>
                <a href={`mailto:${selected.contactPersonEmail}`} style={{ color: "#7c3aed", textDecoration: "none" }}>{selected.contactPersonEmail}</a>
              </div>
            )}
            {selected.contactPersonPhone && (
              <div style={{ fontSize: "0.84rem", color: "#555", display: "flex", alignItems: "center", gap: 6 }}>
                <span>📞</span> {selected.contactPersonPhone}
              </div>
            )}
          </div>

          {/* Address block (right) */}
          <div style={{ fontSize: "0.83rem", color: "#444", lineHeight: 1.85, minWidth: 180 }}>
            {selected.regAddressLine1 && <div>{selected.regAddressLine1}</div>}
            {selected.regAddressLine2 && <div>{selected.regAddressLine2}</div>}
            <div>
              {selected.regCity && <span>{selected.regCity}  </span>}
              {selected.regPincode && <span>{selected.regPincode}  </span>}
              {selected.regState && <span>{selected.regState} (IN)</span>}
            </div>
            <div>India</div>
          </div>
        </div>

        {/* ── Key identifiers strip ── */}
        <div style={{ padding: "0 28px", display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0 32px", borderBottom: "1px solid var(--border)" }}>
          <Field label="GSTIN" value={selected.gstNumber} mono />
          <Field label="PAN" value={selected.panNumber} mono />
          <Field label="TAN" value={selected.tanNumber} mono />
        </div>

        {/* ── Tabs ── */}
        <div style={{ display: "flex", borderBottom: "1px solid var(--border)", padding: "0 28px" }}>
          {tabs.map((t) => (
            <button
              key={t}
              onClick={() => setActiveTab(t)}
              style={{
                padding: "11px 18px", border: "none",
                borderBottom: activeTab === t ? "2px solid #7c3aed" : "2px solid transparent",
                background: "none", cursor: "pointer",
                fontSize: "0.84rem",
                fontWeight: activeTab === t ? 600 : 400,
                color: activeTab === t ? "#7c3aed" : "var(--text-muted)",
                fontFamily: "var(--font-body)",
                marginBottom: -1,
              }}
            >{t}</button>
          ))}
        </div>

        {/* ── Tab content ── */}
        <div style={{ padding: "16px 28px 24px", flex: 1 }}>

          {activeTab === "Contacts" && (
            <div>
              {/* ── Primary contact (from business record) ── */}
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontSize: "0.78rem", fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>Primary Contact (Business Record)</div>
                <div style={{ background: "var(--bg-soft)", borderRadius: 8, padding: "12px 16px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px 24px" }}>
                  <Field label="Name" value={selected.contactPersonName} />
                  <Field label="Designation" value={selected.contactPersonDesignation} />
                  <Field label="Phone" value={selected.contactPersonPhone} />
                  <Field label="Email" value={selected.contactPersonEmail} />
                  <Field label="Website" value={selected.website} />
                </div>
              </div>

              {/* ── Add-contact button + heading ── */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <div style={{ fontSize: "0.78rem", fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                  Additional Contacts {contacts.length > 0 && `(${contacts.length})`}
                </div>
                {!showForm && (
                  <button onClick={openAdd} style={{ display: "flex", alignItems: "center", gap: 5, padding: "5px 14px", border: "1px solid #7c3aed", borderRadius: 6, cursor: "pointer", fontSize: "0.8rem", color: "#7c3aed", background: "rgba(124,58,237,0.05)", fontFamily: "var(--font-body)", fontWeight: 600 }}>
                    + Add Contact
                  </button>
                )}
              </div>

              {/* ── Inline add/edit form ── */}
              {showForm && (
                <div style={{ border: "1px solid #7c3aed", borderRadius: 10, padding: "18px 20px", marginBottom: 16, background: "rgba(124,58,237,0.02)" }}>
                  <div style={{ fontSize: "0.85rem", fontWeight: 700, marginBottom: 14, color: "#7c3aed" }}>
                    {editingContact ? "✏️ Edit Contact" : "➕ New Contact"}
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px" }}>
                    {[
                      ["Name *",           "name",           "text"],
                      ["Designation",      "designation",    "text"],
                      ["Department",       "department",     "text"],
                      ["Phone",            "phone",          "tel"],
                      ["Alternate Phone",  "alternatePhone", "tel"],
                      ["Email",            "email",          "email"],
                    ].map(([label, key, type]) => (
                      <div key={key}>
                        <label style={{ fontSize: "0.78rem", color: "var(--text-muted)", display: "block", marginBottom: 3 }}>{label}</label>
                        <input
                          type={type}
                          className="form-control"
                          value={form[key]}
                          onChange={(e) => setForm((p) => ({ ...p, [key]: e.target.value }))}
                          style={{ width: "100%", boxSizing: "border-box", fontSize: "0.85rem" }}
                        />
                      </div>
                    ))}
                    <div style={{ gridColumn: "1 / -1" }}>
                      <label style={{ fontSize: "0.78rem", color: "var(--text-muted)", display: "block", marginBottom: 3 }}>Notes</label>
                      <textarea className="form-control" rows={2} value={form.notes} onChange={(e) => setForm((p) => ({ ...p, notes: e.target.value }))} style={{ width: "100%", boxSizing: "border-box", fontSize: "0.85rem" }} />
                    </div>
                    <div style={{ gridColumn: "1 / -1", display: "flex", alignItems: "center", gap: 8 }}>
                      <input type="checkbox" id="isPrimaryChk" checked={form.isPrimary} onChange={(e) => setForm((p) => ({ ...p, isPrimary: e.target.checked }))} />
                      <label htmlFor="isPrimaryChk" style={{ fontSize: "0.83rem", cursor: "pointer" }}>Mark as primary contact</label>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
                    <button onClick={saveContact} disabled={saving} className="btn btn-primary" style={{ minWidth: 90, background: "#7c3aed", borderColor: "#7c3aed" }}>
                      {saving ? "Saving…" : editingContact ? "Update" : "Save"}
                    </button>
                    <button onClick={() => setShowForm(false)} className="btn btn-outline" style={{ minWidth: 80 }}>Cancel</button>
                  </div>
                </div>
              )}

              {/* ── Contacts list ── */}
              {contactsLoading ? (
                <div style={{ padding: "24px 0", textAlign: "center", color: "var(--text-muted)", fontSize: "0.85rem" }}>Loading contacts…</div>
              ) : contacts.length === 0 ? (
                <div style={{ padding: "28px 0", textAlign: "center", color: "var(--text-muted)", fontSize: "0.85rem", borderRadius: 8, border: "1px dashed var(--border)" }}>
                  No additional contacts yet. Click <strong>+ Add Contact</strong> to add one.
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                  {contacts.map((c) => (
                    <div key={c.id} style={{ border: `1px solid ${c.isPrimary ? "rgba(124,58,237,0.35)" : "var(--border)"}`, borderRadius: 9, padding: "12px 16px", background: c.isPrimary ? "rgba(124,58,237,0.03)" : "#fff" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 }}>
                            <span style={{ fontWeight: 700, fontSize: "0.95rem" }}>{c.name}</span>
                            {c.isPrimary && (
                              <span style={{ fontSize: "0.7rem", fontWeight: 600, background: "rgba(124,58,237,0.12)", color: "#7c3aed", padding: "2px 8px", borderRadius: 100 }}>PRIMARY</span>
                            )}
                          </div>
                          <div style={{ fontSize: "0.82rem", color: "var(--text-muted)", display: "flex", flexWrap: "wrap", gap: "2px 16px" }}>
                            {c.designation && <span>💼 {c.designation}</span>}
                            {c.department && <span>🏢 {c.department}</span>}
                            {c.phone && <span>📞 {c.phone}</span>}
                            {c.alternatePhone && <span>📞 {c.alternatePhone}</span>}
                            {c.email && <span>✉ <a href={`mailto:${c.email}`} style={{ color: "#7c3aed", textDecoration: "none" }}>{c.email}</a></span>}
                          </div>
                          {c.notes && <div style={{ marginTop: 6, fontSize: "0.78rem", color: "var(--text-muted)", fontStyle: "italic" }}>📝 {c.notes}</div>}
                        </div>
                        <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                          <button onClick={() => openEdit(c)} style={{ padding: "4px 10px", border: "1px solid var(--border)", borderRadius: 5, cursor: "pointer", fontSize: "0.75rem", background: "#fff", fontFamily: "var(--font-body)" }}>✏️ Edit</button>
                          <button onClick={() => deleteContact(c.id)} style={{ padding: "4px 10px", border: "1px solid rgba(239,68,68,0.3)", borderRadius: 5, cursor: "pointer", fontSize: "0.75rem", color: "#ef4444", background: "rgba(239,68,68,0.04)", fontFamily: "var(--font-body)" }}>🗑</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {selected.user && (
                <div style={{ marginTop: 16, padding: "10px 14px", background: "var(--bg-soft)", borderRadius: 8, fontSize: "0.82rem", color: "var(--text-muted)" }}>
                  👤 Registered by: <strong>{selected.user.name}</strong> · {selected.user.email} · {selected.user.phone}
                </div>
              )}
            </div>
          )}

          {activeTab === "Business Info" && (
            <div>
              <Field label="Company Type" value={COMPANY_TYPES[selected.companyType] || selected.companyType} />
              <Field label="Industry" value={selected.industry} />
              <Field label="Udyam Number" value={selected.udyamNumber} mono />
              <div style={{ marginTop: 16, fontSize: "0.83rem", fontWeight: 600, color: "var(--text-muted)", marginBottom: 4 }}>Registered Address</div>
              <Field label="Address Line 1" value={selected.regAddressLine1} />
              <Field label="Address Line 2" value={selected.regAddressLine2} />
              <Field label="City" value={selected.regCity} />
              <Field label="State" value={selected.regState} />
              <Field label="Pincode" value={selected.regPincode} />
              {selected.commAddressLine1 && (
                <>
                  <div style={{ marginTop: 16, fontSize: "0.83rem", fontWeight: 600, color: "var(--text-muted)", marginBottom: 4 }}>Communication Address</div>
                  <Field label="Address Line 1" value={selected.commAddressLine1} />
                  <Field label="Address Line 2" value={selected.commAddressLine2} />
                  <Field label="City" value={selected.commCity} />
                  <Field label="State" value={selected.commState} />
                  <Field label="Pincode" value={selected.commPincode} />
                </>
              )}
              <Field label="Registered On" value={new Date(selected.createdAt).toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })} />
            </div>
          )}

          {activeTab === "Bank & Docs" && (
            <div>
              <Field label="Bank Name" value={selected.bankName} />
              <Field label="Branch" value={selected.branchName} />
              <Field label="IFSC Code" value={selected.ifscCode} mono />
              <Field label="Account Number" value={selected.accountNumber} mono />
              <div style={{ marginTop: 16, fontSize: "0.83rem", fontWeight: 600, color: "var(--text-muted)", marginBottom: 4 }}>Documents</div>
              {[
                ["Company Logo", selected.logoUrl],
                ["GST Certificate", selected.gstDocUrl],
                ["PAN Certificate", selected.panDocUrl],
                ["TAN Certificate", selected.tanDocUrl],
                ["Udyam Certificate", selected.udyamDocUrl],
              ].map(([label, url]) =>
                url ? (
                  <div key={label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid var(--border)" }}>
                    <span style={{ fontSize: "0.83rem", color: "var(--text-muted)", fontWeight: 500 }}>{label}</span>
                    <a href={url} target="_blank" rel="noopener noreferrer" style={{ fontSize: "0.78rem", color: "#7c3aed", textDecoration: "none", border: "1px solid #7c3aed", borderRadius: 4, padding: "3px 10px" }}>View ↗</a>
                  </div>
                ) : (
                  <div key={label} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "9px 0", borderBottom: "1px solid var(--border)" }}>
                    <span style={{ fontSize: "0.83rem", color: "var(--text-muted)", fontWeight: 500 }}>{label}</span>
                    <span style={{ fontSize: "0.78rem", color: "#ccc", fontStyle: "italic" }}>Not uploaded</span>
                  </div>
                )
              )}
            </div>
          )}

          {activeTab === "Notes" && (
            <div>
              {selected.notes && (
                <div style={{ padding: "10px 14px", background: "rgba(245,158,11,0.05)", border: "1px solid rgba(245,158,11,0.2)", borderRadius: 8, fontSize: "0.84rem", color: "#d97706", marginBottom: 16 }}>
                  📝 {selected.notes}
                </div>
              )}
              <label style={{ fontSize: "0.85rem", fontWeight: 600, display: "block", marginBottom: 6 }}>Admin Notes</label>
              <textarea
                className="form-control"
                rows={4}
                id="admin-notes"
                defaultValue={selected.notes || ""}
                placeholder="Add internal notes about this business..."
                style={{ width: "100%", boxSizing: "border-box" }}
              />
            </div>
          )}

          {activeTab === "Credit" && (
            <div>
              {/* ── CARD VIEW (after save) ── */}
              {!creditEditMode && (savedCredit.creditLimit != null || savedCredit.creditTenureDays != null || savedCredit.creditTerms) ? (
                <div style={{ border: "1px solid var(--border)", borderRadius: 9, padding: "12px 16px", background: savedCredit.creditLimit === 0 ? "rgba(239,68,68,0.03)" : "#fff" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                    {/* ── Left: details ── */}
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 4 }}>
                        <span style={{ fontWeight: 700, fontSize: "0.95rem" }}>
                          {savedCredit.creditLimit != null ? `₹${Number(savedCredit.creditLimit).toLocaleString("en-IN")}` : "No limit set"}
                        </span>
                        {savedCredit.creditLimit === 0 && (
                          <span style={{ fontSize: "0.7rem", fontWeight: 600, background: "rgba(239,68,68,0.1)", color: "#ef4444", padding: "2px 8px", borderRadius: 100 }}>DEACTIVATED</span>
                        )}
                        {savedCredit.creditLimit > 0 && (
                          <span style={{ fontSize: "0.7rem", fontWeight: 600, background: "rgba(5,150,105,0.1)", color: "#059669", padding: "2px 8px", borderRadius: 100 }}>ACTIVE</span>
                        )}
                      </div>
                      <div style={{ fontSize: "0.82rem", color: "var(--text-muted)", display: "flex", flexWrap: "wrap", gap: "2px 16px" }}>
                        {savedCredit.creditTenureDays != null && <span>📅 {savedCredit.creditTenureDays} days tenure</span>}
                        {savedCredit.creditTerms && <span>📄 Terms set</span>}
                      </div>
                      {savedCredit.creditTerms && (
                        <div style={{ marginTop: 6, fontSize: "0.78rem", color: "var(--text-muted)", fontStyle: "italic" }}>
                          📝 {savedCredit.creditTerms.length > 100 ? savedCredit.creditTerms.slice(0, 100) + "…" : savedCredit.creditTerms}
                        </div>
                      )}
                    </div>
                    {/* ── Right: action buttons ── */}
                    <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                      <button
                        onClick={() => { setCredit({ creditLimit: savedCredit.creditLimit ?? "", creditTenureDays: savedCredit.creditTenureDays ?? "", creditTerms: savedCredit.creditTerms ?? "" }); setCreditEditMode(true); }}
                        style={{ padding: "4px 10px", border: "1px solid var(--border)", borderRadius: 5, cursor: "pointer", fontSize: "0.75rem", background: "#fff", fontFamily: "var(--font-body)" }}
                      >✏️ Edit</button>
                      <button
                        onClick={toggleCreditActive}
                        disabled={creditSaving}
                        style={{ padding: "4px 10px", border: `1px solid ${savedCredit.creditLimit === 0 ? "rgba(5,150,105,0.3)" : "rgba(245,158,11,0.3)"}`, borderRadius: 5, cursor: "pointer", fontSize: "0.75rem", color: savedCredit.creditLimit === 0 ? "#059669" : "#d97706", background: savedCredit.creditLimit === 0 ? "rgba(5,150,105,0.04)" : "rgba(245,158,11,0.04)", fontFamily: "var(--font-body)" }}
                      >{savedCredit.creditLimit === 0 ? "✅ Activate" : "⏸ Deactivate"}</button>
                      <button
                        onClick={deleteCredit}
                        disabled={creditSaving}
                        style={{ padding: "4px 10px", border: "1px solid rgba(239,68,68,0.3)", borderRadius: 5, cursor: "pointer", fontSize: "0.75rem", color: "#ef4444", background: "rgba(239,68,68,0.04)", fontFamily: "var(--font-body)" }}
                      >🗑 Delete</button>
                    </div>
                  </div>

                  {/* ── Live usage summary from sales orders ── */}
                  {creditSummaryLoading && (
                    <div style={{ marginTop: 12, fontSize: "0.78rem", color: "var(--text-muted)" }}>Loading credit usage…</div>
                  )}
                  {!creditSummaryLoading && creditSummary && savedCredit.creditLimit > 0 && (
                    <div style={{ marginTop: 14, borderTop: "1px solid var(--border)", paddingTop: 12 }}>
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 12 }}>
                        {[
                          { label: "Total Limit", value: `₹${Number(creditSummary.creditLimit).toLocaleString("en-IN")}`, color: "#7c3aed" },
                          { label: "Used", value: `₹${Number(creditSummary.usedCredit).toLocaleString("en-IN")}`, color: "#ef4444" },
                          { label: "Available", value: `₹${Number(creditSummary.availableCredit).toLocaleString("en-IN")}`, color: "#059669" },
                        ].map(({ label, value, color }) => (
                          <div key={label} style={{ background: "var(--bg-soft)", borderRadius: 7, padding: "8px 10px", textAlign: "center" }}>
                            <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", marginBottom: 3 }}>{label}</div>
                            <div style={{ fontSize: "0.9rem", fontWeight: 700, color }}>{value}</div>
                          </div>
                        ))}
                      </div>
                      <div style={{ height: 6, borderRadius: 99, background: "#f0f0f0", overflow: "hidden", marginBottom: 12 }}>
                        <div style={{
                          height: "100%", borderRadius: 99,
                          width: `${Math.min(100, (creditSummary.usedCredit / creditSummary.creditLimit) * 100)}%`,
                          background: creditSummary.usedCredit / creditSummary.creditLimit > 0.8 ? "#ef4444" : "#7c3aed",
                          transition: "width 0.4s",
                        }} />
                      </div>
                      {creditSummary.creditHistory && creditSummary.creditHistory.length > 0 ? (
                        <div>
                          <div style={{ fontSize: "0.72rem", fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 8 }}>
                            Credit History ({creditSummary.creditHistory.length})
                          </div>
                          {/* Header row */}
                          <div style={{ display: "grid", gridTemplateColumns: "1.4fr 0.8fr 0.9fr 0.9fr 0.8fr", gap: 4, padding: "4px 8px", fontSize: "0.7rem", fontWeight: 700, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.04em", borderBottom: "1px solid var(--border)" }}>
                            <span>Order</span>
                            <span style={{ textAlign: "right" }}>Amount</span>
                            <span style={{ textAlign: "center" }}>Date</span>
                            <span style={{ textAlign: "center" }}>Due Date</span>
                            <span style={{ textAlign: "center" }}>Status</span>
                          </div>
                          {creditSummary.creditHistory.map((h, i) => (
                            <div key={i} style={{ display: "grid", gridTemplateColumns: "1.4fr 0.8fr 0.9fr 0.9fr 0.8fr", gap: 4, padding: "6px 8px", borderBottom: "1px solid var(--border)", fontSize: "0.8rem", background: h.creditStatus === 'pending' ? "rgba(239,68,68,0.02)" : "rgba(5,150,105,0.02)", alignItems: "center" }}>
                              <span style={{ fontWeight: 600, color: "#7c3aed" }}>{h.orderNumber}</span>
                              <span style={{ textAlign: "right", fontWeight: 700, color: h.creditStatus === 'pending' ? "#ef4444" : "#059669" }}>
                                ₹{Number(h.amount).toLocaleString("en-IN")}
                              </span>
                              <span style={{ textAlign: "center", color: "var(--text-muted)", fontSize: "0.75rem" }}>{h.date || "—"}</span>
                              <span style={{ textAlign: "center", color: h.creditStatus === 'pending' && h.dueDate && new Date(h.dueDate) < new Date() ? "#ef4444" : "var(--text-muted)", fontSize: "0.75rem", fontWeight: h.creditStatus === 'pending' && h.dueDate && new Date(h.dueDate) < new Date() ? 700 : 400 }}>
                                {h.dueDate || "—"}
                                {h.creditStatus === 'pending' && h.dueDate && new Date(h.dueDate) < new Date() && <span style={{ marginLeft: 4 }}>⚠️</span>}
                              </span>
                              <span style={{ textAlign: "center" }}>
                                <span style={{ fontSize: "0.68rem", fontWeight: 700, padding: "2px 7px", borderRadius: 100, background: h.creditStatus === 'pending' ? "rgba(239,68,68,0.1)" : "rgba(5,150,105,0.1)", color: h.creditStatus === 'pending' ? "#ef4444" : "#059669" }}>
                                  {h.creditStatus === 'pending' ? 'PENDING' : 'SETTLED'}
                                </span>
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div style={{ fontSize: "0.78rem", color: "var(--text-muted)", fontStyle: "italic" }}>No credit history yet.</div>
                      )}
                    </div>
                  )}

                </div>
              ) : (
                /* ── EDIT / ADD FORM ── */
                <div>
                  {/* ── Credit limit ── */}
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ fontSize: "0.83rem", fontWeight: 600, display: "block", marginBottom: 6 }}>Credit limit (₹)</label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <span style={{ position: "absolute", left: 10, fontSize: "0.9rem", color: "var(--text-muted)", pointerEvents: "none" }}>₹</span>
                      <input
                        type="number"
                        className="form-control"
                        min={0}
                        step={1000}
                        value={credit.creditLimit}
                        onChange={(e) => setCredit((c) => ({ ...c, creditLimit: e.target.value }))}
                        placeholder="e.g. 200000"
                        style={{ paddingLeft: 24, width: "100%", boxSizing: "border-box" }}
                      />
                    </div>
                    <div style={{ fontSize: "0.75rem", color: "var(--text-muted)", marginTop: 4 }}>Leave blank to remove credit facility.</div>
                  </div>

                  {/* ── Credit tenure ── */}
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ fontSize: "0.83rem", fontWeight: 600, display: "block", marginBottom: 6 }}>Credit tenure (days)</label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                      <input
                        type="number"
                        className="form-control"
                        min={1}
                        max={365}
                        value={credit.creditTenureDays}
                        onChange={(e) => setCredit((c) => ({ ...c, creditTenureDays: e.target.value }))}
                        placeholder="e.g. 30"
                        style={{ paddingRight: 52, width: "100%", boxSizing: "border-box" }}
                      />
                      <span style={{ position: "absolute", right: 10, fontSize: "0.8rem", color: "var(--text-muted)", pointerEvents: "none" }}>days</span>
                    </div>
                    <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
                      {[30, 45, 60, 90].map((d) => (
                        <button key={d} type="button"
                          onClick={() => setCredit((c) => ({ ...c, creditTenureDays: d }))}
                          style={{ padding: "3px 12px", borderRadius: 6, fontSize: "0.78rem", cursor: "pointer", fontFamily: "var(--font-body)",
                            border: Number(credit.creditTenureDays) === d ? "1px solid #7c3aed" : "1px solid var(--border)",
                            background: Number(credit.creditTenureDays) === d ? "rgba(124,58,237,0.08)" : "#fff",
                            color: Number(credit.creditTenureDays) === d ? "#7c3aed" : "var(--text-muted)",
                          }}
                        >{d} days</button>
                      ))}
                    </div>
                  </div>

                  {/* ── Terms ── */}
                  <div style={{ marginBottom: 20 }}>
                    <label style={{ fontSize: "0.83rem", fontWeight: 600, display: "block", marginBottom: 6 }}>Terms and conditions</label>
                    <textarea
                      className="form-control"
                      rows={5}
                      value={credit.creditTerms}
                      onChange={(e) => setCredit((c) => ({ ...c, creditTerms: e.target.value }))}
                      placeholder="e.g. Payment due within tenure period from invoice date. Late payments attract 2% per month..."
                      style={{ width: "100%", boxSizing: "border-box" }}
                    />
                    <div style={{ fontSize: "0.75rem", color: "var(--text-muted)", marginTop: 4 }}>This text will appear on invoices for this business.</div>
                  </div>

                  <div style={{ display: "flex", gap: 8 }}>
                    <button onClick={saveCredit} disabled={creditSaving} className="btn btn-primary" style={{ background: "#7c3aed", borderColor: "#7c3aed", minWidth: 140 }}>
                      {creditSaving ? "Saving…" : "💾 Save"}
                    </button>
                    {(savedCredit.creditLimit != null || savedCredit.creditTenureDays != null || savedCredit.creditTerms) && (
                      <button onClick={() => setCreditEditMode(false)} className="btn btn-outline" style={{ minWidth: 80 }}>Cancel</button>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* ── Footer action bar ── */}
        <div style={{ padding: "14px 28px", borderTop: "1px solid var(--border)", background: "var(--bg-soft)", display: "flex", gap: 10, borderRadius: "0 0 var(--radius-lg) var(--radius-lg)" }}>
          {!selected.isVerified ? (
            <button
              onClick={() => { setIsVerifiedLive(true); handleVerify(selected.id, true, document.getElementById("admin-notes")?.value || ""); }}
              className="btn btn-primary"
              style={{ background: "#059669", borderColor: "#059669", minWidth: 160 }}
            >
              ✅ Approve Business
            </button>
          ) : (
            <button
              onClick={() => { setIsVerifiedLive(false); handleVerify(selected.id, false, document.getElementById("admin-notes")?.value || ""); }}
              className="btn btn-primary"
              style={{ background: "#ef4444", borderColor: "#ef4444", minWidth: 160 }}
            >
              ❌ Revoke Approval
            </button>
          )}
          <button onClick={onClose} className="btn btn-outline" style={{ minWidth: 100 }}>Close</button>
        </div>
      </div>
    </div>
  );
};

/* ─── Businesses Management ───────────────────────────────────────── */
const BUSINESSES_PAGE_SIZE = 20;

const AdminBusinesses = () => {
  const navigate = useNavigate();
  const { user: currentUser } = useAuth();
  const canEdit = currentUser?.role === 'admin' || canStaffAccess(currentUser?.allowedPages, 'businesses', 'edit');
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");
  const [showAddBusiness, setShowAddBusiness] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [bizStats, setBizStats] = useState({ totalBusinesses: 0, pendingCount: 0, approvedCount: 0 });

  const load = (targetPage = page, searchVal = search) => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filter !== "") params.set("verified", filter);
    if (searchVal.trim()) params.set("search", searchVal.trim());
    params.set("page", targetPage);
    params.set("limit", BUSINESSES_PAGE_SIZE);
    API.get(`/business?${params}`)
      .then((r) => {
        setBusinesses(r.data.businesses || []);
        setTotalPages(r.data.pages || 1);
        setTotalCount(r.data.count || 0);
        if (r.data.stats) setBizStats(r.data.stats);
        setPage(targetPage);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  // Debounce search — fires 350ms after the user stops typing
  useEffect(() => {
    const timer = setTimeout(() => load(1, search), 350);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    load(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  const goPrevBiz = () => { if (page > 1) load(page - 1); };
  const goNextBiz = () => { if (page < totalPages) load(page + 1); };

  const handleVerify = async (id, isVerified, notes = "") => {
    try {
      await API.put(`/business/${id}/verify`, { isVerified, notes });
      toast.success(
        isVerified ? "✅ Business approved!" : "❌ Business rejected!",
      );
      load();
    } catch {
      toast.error("Failed.");
    }
  };

  const COMPANY_TYPES = {
    sole_proprietorship: "Sole Proprietorship",
    partnership: "Partnership",
    private_limited: "Private Limited",
    public_limited: "Public Limited",
    llp: "LLP",
    ngo: "NGO / Trust",
    other: "Other",
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        <h2>
          Businesses{" "}
          <span
            style={{
              fontSize: "1rem",
              color: "var(--text-muted)",
              fontWeight: 400,
            }}
          >
            ({totalCount})
          </span>
        </h2>
        <div
          style={{
            display: "flex",
            gap: 10,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <select
            className="form-control"
            style={{ width: "auto", fontSize: "0.88rem" }}
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="">All Businesses</option>
            <option value="false">⏳ Pending Approval</option>
            <option value="true">✅ Approved</option>
          </select>
          {canEdit && (
            <button
              onClick={() => setShowAddBusiness(true)}
              className="btn btn-primary btn-sm"
              style={{ display: "flex", alignItems: "center", gap: 6 }}
            >
              ➕ Add Business
            </button>
          )}
        </div>
      </div>
      <div className="admin-stat-grid">
        {[
          {
            label: "Total Businesses",
            value: bizStats.totalBusinesses,
            color: "#3b82f6",
            emoji: "🏢",
          },
          {
            label: "Pending Approval",
            value: bizStats.pendingCount,
            color: "#f59e0b",
            emoji: "⏳",
          },
          { label: "Approved", value: bizStats.approvedCount, color: "#059669", emoji: "✅" },
        ].map((s) => (
          <div
            key={s.label}
            style={{
              background: "#fff",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius-lg)",
              padding: "16px 20px",
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <span style={{ fontSize: "1.8rem" }}>{s.emoji}</span>
            <div>
              <div
                style={{
                  fontSize: "1.6rem",
                  fontWeight: 800,
                  fontFamily: "var(--font-display)",
                  color: s.color,
                  lineHeight: 1,
                }}
              >
                {s.value}
              </div>
              <div
                style={{
                  fontSize: "0.78rem",
                  color: "var(--text-muted)",
                  marginTop: 2,
                }}
              >
                {s.label}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ── Business search box ── */}
      <div style={{ marginBottom: 16, marginTop: 4, position: "relative" }}>
        <FiSearch
          size={16}
          style={{
            position: "absolute",
            left: 12,
            top: "50%",
            transform: "translateY(-50%)",
            color: "var(--text-muted)",
            pointerEvents: "none",
          }}
        />
        <input
          type="text"
          className="form-control"
          placeholder="Search by name, email, phone, city, GST…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: "100%", fontSize: "0.9rem", paddingLeft: 36 }}
        />
      </div>

      {bizStats.pendingCount > 0 && (
        <div
          style={{
            background: "rgba(245,158,11,0.08)",
            border: "1px solid rgba(245,158,11,0.3)",
            borderRadius: "var(--radius)",
            padding: "12px 16px",
            marginBottom: 20,
            fontSize: "0.88rem",
            color: "#d97706",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          ⚠️{" "}
          <strong>
            {bizStats.pendingCount} business{bizStats.pendingCount > 1 ? "es" : ""}
          </strong>{" "}
          waiting for your approval.
        </div>
      )}
      {loading ? (
        <div className="spinner" />
      ) : businesses.length === 0 ? (
        <div
          style={{
            background: "#fff",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-lg)",
            padding: 48,
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: "3rem", marginBottom: 12 }}>🏢</div>
          <h3>No businesses found</h3>
          <p style={{ color: "var(--text-muted)", marginTop: 8 }}>
            Business registrations will appear here.
          </p>
        </div>
      ) : (
        <div
          style={{
            background: "#fff",
            border: "1px solid var(--border)",
            borderRadius: "var(--radius-lg)",
            overflow: "hidden",
          }}
        >
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.875rem",
              }}
            >
              <thead>
                <tr
                  style={{
                    background: "var(--bg-soft)",
                    borderBottom: "1px solid var(--border)",
                  }}
                >
                  {[
                    "Company Name",
                    "Type",
                    "GST Number",
                    "City",
                    "Status",
                  ].map((h) => (
                    <th
                      key={h}
                      style={{
                        padding: "12px 16px",
                        textAlign: "left",
                        fontWeight: 600,
                        fontSize: "0.78rem",
                        color: "var(--text-muted)",
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {businesses.map((b, idx) => (
                  <tr
                    key={b.id}
                    onClick={() => navigate(`/admin/businesses/${b.id}`)}
                    style={{
                      borderBottom:
                        idx < businesses.length - 1
                          ? "1px solid var(--border)"
                          : "none",
                      background: !b.isVerified
                        ? "rgba(245,158,11,0.02)"
                        : "#fff",
                      transition: "background 0.15s",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.background = "var(--bg-soft)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.background = !b.isVerified
                        ? "rgba(245,158,11,0.02)"
                        : "#fff")
                    }
                  >
                    {/* Company Name */}
                    <td style={{ padding: "14px 16px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <div
                          style={{
                            width: 36,
                            height: 36,
                            background: "rgba(124,58,237,0.1)",
                            color: "#7c3aed",
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "1rem",
                            flexShrink: 0,
                          }}
                        >
                          🏢
                        </div>
                        <div>
                          <div style={{ fontWeight: 600, color: "#111" }}>
                            {b.companyName}
                          </div>
                          <div
                            style={{
                              fontSize: "0.75rem",
                              color: "var(--text-muted)",
                              marginTop: 2,
                            }}
                          >
                            {b.industry}
                          </div>
                        </div>
                      </div>
                    </td>

                    {/* Type */}
                    <td
                      style={{
                        padding: "14px 16px",
                        color: "var(--text-muted)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {COMPANY_TYPES[b.companyType] || b.companyType}
                    </td>

                    {/* GST Number */}
                    <td style={{ padding: "14px 16px" }}>
                      {b.gstNumber ? (
                        <span
                          style={{
                            fontFamily: "monospace",
                            fontSize: "0.82rem",
                            background: "var(--bg-soft)",
                            padding: "2px 8px",
                            borderRadius: 4,
                            border: "1px solid var(--border)",
                          }}
                        >
                          {b.gstNumber}
                        </span>
                      ) : (
                        <span style={{ color: "var(--text-muted)", fontSize: "0.8rem" }}>
                          —
                        </span>
                      )}
                    </td>

                    {/* City */}
                    <td
                      style={{
                        padding: "14px 16px",
                        color: "var(--text-muted)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      📍 {b.regCity}
                    </td>

                    {/* Status */}
                    <td style={{ padding: "14px 16px", whiteSpace: "nowrap" }}>
                      <span
                        style={{
                          padding: "4px 10px",
                          borderRadius: 100,
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          background: b.isVerified
                            ? "rgba(5,150,105,0.1)"
                            : "rgba(245,158,11,0.1)",
                          color: b.isVerified ? "#059669" : "#d97706",
                        }}
                      >
                        {b.isVerified ? "✅ Approved" : "⏳ Pending"}
                      </span>
                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Pagination */}
      {!loading && businesses.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 14,
            marginTop: 18,
          }}
        >
          <button
            className="btn btn-outline btn-sm"
            onClick={goPrevBiz}
            disabled={page <= 1}
            style={{ opacity: page <= 1 ? 0.5 : 1 }}
          >
            ← Prev
          </button>
          <span style={{ fontSize: "0.85rem", color: "var(--text-muted)" }}>
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-outline btn-sm"
            onClick={goNextBiz}
            disabled={page >= totalPages}
            style={{ opacity: page >= totalPages ? 0.5 : 1 }}
          >
            Next →
          </button>
        </div>
      )}
      {/* Add Business Modal */}
      {showAddBusiness && (
        <AddBusinessModal
          onClose={() => setShowAddBusiness(false)}
          onCreated={() => {
            setShowAddBusiness(false);
            load();
          }}
        />
      )}
    </div>
  );
};

/* ─── Staff: No Access Page ──────────────────────────────────────── */
const StaffNoAccess = () => (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", textAlign: "center", gap: 12 }}>
    <FiAlertCircle size={48} style={{ color: "#dc2626", opacity: 0.5 }} />
    <div style={{ fontSize: "1.2rem", fontWeight: 700, color: "var(--text)" }}>Access Denied</div>
    <div style={{ fontSize: "0.88rem", color: "var(--text-muted)", maxWidth: 360 }}>
      You don't have permission to view this section. Contact your administrator to request access.
    </div>
  </div>
);

/* ─── Admin-only Route Guard ────────────────────────────────────── */
const AdminOnlyRoute = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <StaffNoAccess />;
};

/* ─── Staff: Route Guard ─────────────────────────────────────────── */
const StaffRoute = ({ pageKey, children }) => {
  const { user } = useAuth();
  if (user?.role === "admin") return children;
  if (user?.role === "staff") {
    if (!pageKey) return children; // no key = always allow (e.g. dashboard)
    return canStaffAccess(user.allowedPages, pageKey) ? children : <StaffNoAccess />;
  }
  return <StaffNoAccess />;
};

const AdminPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // Normalise allowedPages — MySQL JSON can return as string
  if (user && typeof user.allowedPages === 'string') {
    try { user.allowedPages = JSON.parse(user.allowedPages); } catch { user.allowedPages = []; }
  }

  useEffect(() => {
    if (!user) navigate("/login");
    else if (user.role !== "admin" && user.role !== "staff") navigate("/login");
  }, [user, navigate]);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className={`admin-shell${sidebarCollapsed ? " sidebar-is-collapsed" : ""}`}>
      {/* Hamburger — mobile only */}
      <button
        className="admin-hamburger"
        onClick={() => setSidebarOpen(o => !o)}
        aria-label="Toggle menu"
      >
        {sidebarOpen ? "✕" : "☰"}
      </button>

      <AdminSidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(c => !c)}
      />

      <main className="admin-main">
        <Routes>
          <Route index element={<AdminDashboard />} />
          <Route path="products"                  element={<StaffRoute pageKey="products"><AdminAllProducts /></StaffRoute>} />
          <Route path="products/add"              element={<StaffRoute pageKey="products"><AdminProductForm /></StaffRoute>} />
          <Route path="products/:id/edit"         element={<StaffRoute pageKey="products"><AdminProductForm /></StaffRoute>} />
          <Route path="products/:id/preview"      element={<StaffRoute pageKey="products"><AdminProductPreview /></StaffRoute>} />
          <Route path="catalog/categories"        element={<StaffRoute pageKey="catalog"><AdminCategories /></StaffRoute>} />
          <Route path="search-analytics"          element={<StaffRoute pageKey="search-analytics"><AdminSearchAnalytics /></StaffRoute>} />
          <Route path="orders" element={<StaffRoute pageKey="sales-orders"><AdminOrders /></StaffRoute>} />
          <Route path="users" element={<StaffRoute pageKey="users"><AdminUsers /></StaffRoute>} />
          <Route path="businesses" element={<StaffRoute pageKey="businesses"><AdminBusinesses /></StaffRoute>} />
          <Route path="businesses/:id" element={<StaffRoute pageKey="businesses"><AdminBusinessDetail /></StaffRoute>} />
          <Route path="contacts" element={<StaffRoute pageKey="contacts"><AdminContacts /></StaffRoute>} />
          <Route path="quote-requests" element={<StaffRoute pageKey="quote-requests"><AdminQuoteRequests /></StaffRoute>} />
          <Route path="quotations/*" element={<StaffRoute pageKey="quotations"><AdminCRM /></StaffRoute>} />
          <Route path="sales-orders/*" element={<StaffRoute pageKey="sales-orders"><SalesOrders /></StaffRoute>} />
          <Route path="order-detail/*" element={<StaffRoute pageKey="order-detail"><OrderDetailModule /></StaffRoute>} />
          <Route path="payments" element={<StaffRoute pageKey="payments"><AdminPayments /></StaffRoute>} />
          <Route path="billing" element={<StaffRoute pageKey="billing"><AdminBilling /></StaffRoute>} />
          <Route path="billing/:billId" element={<StaffRoute pageKey="billing"><BillDetail /></StaffRoute>} />
          <Route path="payment-terms" element={<AdminOnlyRoute><AdminPaymentTerms /></AdminOnlyRoute>} />
          <Route path="production" element={<StaffRoute pageKey="production"><AdminProduction /></StaffRoute>} />
          <Route path="delivered"      element={<StaffRoute pageKey="delivered"><AdminDelivered /></StaffRoute>} />
          <Route path="site-settings"   element={<AdminOnlyRoute><AdminSiteSettings /></AdminOnlyRoute>} />
          <Route path="email-settings"  element={<AdminOnlyRoute><AdminEmailSettings /></AdminOnlyRoute>} />
          <Route path="client-logos"    element={<StaffRoute pageKey="client-logos"><AdminClientLogos /></StaffRoute>} />
          <Route path="about-us"        element={<StaffRoute pageKey="about-us"><AdminAboutUs /></StaffRoute>} />
          <Route path="vendor-types"        element={<StaffRoute pageKey="vendor-types"><AdminVendorTypes /></StaffRoute>} />
          <Route path="vendors"             element={<StaffRoute pageKey="vendors"><AdminVendors /></StaffRoute>} />
          <Route path="vendors/new"         element={<StaffRoute pageKey="vendors"><AdminVendorForm /></StaffRoute>} />
          <Route path="vendors/:id"         element={<StaffRoute pageKey="vendors"><AdminVendorDetail /></StaffRoute>} />
          <Route path="vendors/:id/edit"    element={<StaffRoute pageKey="vendors"><AdminVendorForm /></StaffRoute>} />
          <Route path="vendor-payments"          element={<StaffRoute pageKey="vendor-payments"><AdminVendorPayments /></StaffRoute>} />
          <Route path="vendor-payments/:paymentId" element={<StaffRoute pageKey="vendor-payments"><AdminVendorPaymentDetail /></StaffRoute>} />
          <Route path="purchases"           element={<StaffRoute pageKey="purchases"><AdminPurchases /></StaffRoute>} />
          <Route path="purchases/new"       element={<StaffRoute pageKey="purchases"><AdminPurchaseForm /></StaffRoute>} />
          <Route path="purchases/:id"       element={<StaffRoute pageKey="purchases"><AdminPurchaseDetail /></StaffRoute>} />
          <Route path="purchases/:id/edit"  element={<StaffRoute pageKey="purchases"><AdminPurchaseForm /></StaffRoute>} />
          <Route path="services"            element={<StaffRoute pageKey="services"><AdminServices /></StaffRoute>} />
          <Route path="public-services"     element={<StaffRoute pageKey="public-services"><AdminPublicServices /></StaffRoute>} />
          <Route path="contact-hero"        element={<StaffRoute pageKey="contact-hero"><AdminContactHero /></StaffRoute>} />
          {/* <Route path="cash-bank"               element={<AdminCashBank />} /> */}
          <Route path="bank-accounts"           element={<AdminOnlyRoute><AdminBankAccounts /></AdminOnlyRoute>} />
          <Route path="expenses"                element={<StaffRoute pageKey="expenses"><AdminExpenses /></StaffRoute>} />
          <Route path="expenses/new"            element={<StaffRoute pageKey="expenses"><AdminExpenseForm /></StaffRoute>} />
          <Route path="expenses/reports"        element={<StaffRoute pageKey="expenses"><AdminExpenseReports /></StaffRoute>} />
          <Route path="expenses/:id"            element={<StaffRoute pageKey="expenses"><AdminExpenseDetail /></StaffRoute>} />
          <Route path="expenses/:id/edit"       element={<StaffRoute pageKey="expenses"><AdminExpenseForm /></StaffRoute>} />
          <Route path="expense-categories"      element={<StaffRoute pageKey="expense-categories"><AdminExpenseCategories /></StaffRoute>} />
          <Route path="ledger"                  element={<StaffRoute pageKey="ledger"><AdminLedger /></StaffRoute>} />
          <Route path="tds"                     element={<StaffRoute pageKey="tds"><AdminTds /></StaffRoute>} />
          {/* ── Staff management (admin only) ── */}
          <Route path="staff" element={<AdminOnlyRoute><AdminStaff /></AdminOnlyRoute>} />
        </Routes>
      </main>
    </div>
  );
};

export default AdminPage;